import { render } from "./Over.vue?vue&type=template&id=6378f482"
import script from "./Over.vue?vue&type=script&lang=js"
export * from "./Over.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__